// src/App.js - VERSÃO FINAL
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import MainLayout from './components/Layout/MainLayout';
import Login from './components/Login';
import LinhaTempo from './pages/LinhaTempo';
import Produtividade from './pages/Produtividade';
import RelatorioTabular from './pages/RelatorioTabular';
import RelatorioProducaoSetor from './pages/RelatorioProducaoSetor';
import RelatorioVolumeProducao from './pages/RelatorioVolumeProducao';
import RelatorioEncapsulacao from './pages/RelatorioEncapsulacao';
import RelatorioEncapsulacaoDetalhado from './pages/RelatorioEncapsulacaoDetalhado';
import RelatorioPerformance from './pages/RelatorioPerformance';
import RelatorioProducaoCapsulas from './pages/RelatorioProducaoCapsulas';
import Funcionarios from './pages/Funcionarios';
import Setores from './pages/Setores';
import CadastroUsuario from './pages/CadastroUsuario';
import { CircularProgress, Box } from '@mui/material';

const LoadingScreen = () => <Box display="flex" justifyContent="center" alignItems="center" height="100vh"><CircularProgress /></Box>;

const ProtectedRoute = ({ children, requiredLevel = 1 }) => {
  const { user, loading, hasPermission } = useAuth();
  if (loading) return <LoadingScreen />;
  // Só permite acesso se o usuário existir e tiver id válido
  if (!user || typeof user.id === 'undefined' || user.id === null) {
    localStorage.removeItem('user');
    return <Navigate to="/login" replace />;
  }
  if (!hasPermission(requiredLevel)) return <Navigate to="/linha-tempo" replace />;
  return children;
};

const LayoutWithOutlet = () => (
  <MainLayout>
    <Outlet />
  </MainLayout>
);

const AppRoutes = () => {
  const { user, loading } = useAuth();
  if (loading) return <LoadingScreen />;

  return (
    <Routes>
      <Route path="/login" element={!user ? <Login /> : <Navigate to="/linha-tempo" replace />} />
      <Route path="/" element={user ? <LayoutWithOutlet /> : <Navigate to="/login" replace />}>
        <Route index element={<Navigate to="/linha-tempo" replace />} />
        <Route path="linha-tempo" element={<ProtectedRoute requiredLevel={1}><LinhaTempo /></ProtectedRoute>} />
        <Route path="produtividade" element={<ProtectedRoute requiredLevel={2}><Produtividade /></ProtectedRoute>} />
        <Route path="relatorio-tabular" element={<ProtectedRoute requiredLevel={2}><RelatorioTabular /></ProtectedRoute>} />
        <Route path="relatorio-producao-setor" element={<ProtectedRoute requiredLevel={2}><RelatorioProducaoSetor /></ProtectedRoute>} />
        <Route path="relatorio-volume-producao" element={<ProtectedRoute requiredLevel={2}><RelatorioVolumeProducao /></ProtectedRoute>} />
        <Route path="relatorio-encapsulacao" element={<ProtectedRoute requiredLevel={2}><RelatorioEncapsulacao /></ProtectedRoute>} />
        <Route path="relatorio-encapsulacao-detalhado" element={<ProtectedRoute requiredLevel={2}><RelatorioEncapsulacaoDetalhado /></ProtectedRoute>} />
        <Route path="relatorio-performance" element={<ProtectedRoute requiredLevel={2}><RelatorioPerformance /></ProtectedRoute>} />
        <Route path="relatorio-producao-capsulas" element={<ProtectedRoute requiredLevel={2}><RelatorioProducaoCapsulas /></ProtectedRoute>} />
        <Route path="funcionarios" element={<ProtectedRoute requiredLevel={2}><Funcionarios /></ProtectedRoute>} />
        <Route path="setores" element={<ProtectedRoute requiredLevel={2}><Setores /></ProtectedRoute>} />
        <Route path="usuarios" element={<ProtectedRoute requiredLevel={3}><CadastroUsuario /></ProtectedRoute>} />
      </Route>
      <Route path="*" element={<Navigate to={user ? "/linha-tempo" : "/login"} replace />} />
    </Routes>
  );
};

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <AppRoutes />
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
